var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 65226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.5,
    d: "M11.619 17.2381C12.6667 17.2381 13.5238 16.381 13.5238 15.3333C13.5238 14.2857 12.6667 13.4286 11.619 13.4286C10.5714 13.4286 9.71429 14.2857 9.71429 15.3333C9.71429 16.381 10.5714 17.2381 11.619 17.2381ZM17.3333 8.66667H16.381V6.7619C16.381 4.13333 14.2476 2 11.619 2C8.99048 2 6.85714 4.13333 6.85714 6.7619H8.66667C8.66667 5.13333 9.99048 3.80952 11.619 3.80952C13.2476 3.80952 14.5714 5.13333 14.5714 6.7619V8.66667H5.90476C4.85714 8.66667 4 9.52381 4 10.5714V20.0952C4 21.1429 4.85714 22 5.90476 22H17.3333C18.381 22 19.2381 21.1429 19.2381 20.0952V10.5714C19.2381 9.52381 18.381 8.66667 17.3333 8.66667ZM17.3333 20.0952H5.90476V10.5714H17.3333V20.0952Z",
    fill: "#03014C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a841c1183a974b317c106b74a4277e4d.svg";
export { ForwardRef as ReactComponent };